import { colors, styles } from '../styles/styles';

export const filterDrawerStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 999,
        transition: styles.transitions.default,
    },

    drawer: {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '952px',
        backgroundColor: colors.surfaceElevated,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        borderTopLeftRadius: styles.borderRadius.xl,
        borderTopRightRadius: styles.borderRadius.xl,
        boxShadow: '0px -4px 24px rgba(0, 0, 0, 0.15)',
        transition: styles.transitions.default,
        maxHeight: '80vh',
        overflowY: 'auto',
        paddingTop: styles.spacing.md,
        paddingBottom: styles.spacing.lg
    },

    header: {
        container: {
            padding: `${styles.spacing.sm} ${styles.spacing.md} ${styles.spacing.md}`,
        },
        wrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        title: {
            fontSize: styles.typography.h3.fontSize,
            fontWeight: styles.typography.fontWeightBold,
            color: colors.textPrimary,
            margin: 0,
        },
        clearButton: {
            backgroundColor: 'transparent',
            border: 'none',
            color: colors.accent.white,
            fontSize: styles.typography.label.fontSize,
            fontWeight: styles.typography.fontWeightMedium,
            cursor: 'pointer',
            padding: `${styles.spacing.xs} ${styles.spacing.sm}`,
        }
    },

    tagsSection: {
        container: {
            padding: styles.spacing.md
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: styles.spacing.sm,
        },
        tagButton: (isSelected) => ({
            backgroundColor: isSelected ? colors.accent.white : colors.surface,
            color: isSelected ? 'black' : colors.textPrimary,
            border: `1px solid ${isSelected ? colors.accent.white : colors.divider}`,
            borderRadius: '16px',
            padding: `${styles.spacing.xs} ${styles.spacing.sm}`,
            fontSize: styles.typography.label.fontSize,
            fontWeight: styles.typography.fontWeightMedium,
            cursor: 'pointer',
            transition: styles.transitions.default,
        })
    },

    emptyState: {
        padding: `${styles.spacing.xxl} ${styles.spacing.md}`,
        textAlign: 'center',
        color: colors.textSecondary
    },

    actions: {
        container: {
            padding: `${styles.spacing.sm} ${styles.spacing.md} 0`,
            display: 'flex',
            justifyContent: 'center'
        },
        applyButton: {
            padding: `${styles.spacing.sm} ${styles.spacing.lg}`,
            backgroundColor: 'transparent',
            border: 'none',
            fontSize: styles.typography.body.fontSize,
            fontWeight: styles.typography.fontWeightBold,
            color: colors.accent.white,
            cursor: 'pointer',
        }
    }
}; 